export const MY_TICKETS = "myTickets";
export const CHECK_TICKETS = "checkTickets";
export const APPROVE_TICKETS = "approveTickets";
export const ATTEND_TICKETS = "attendTickets";
